import React, { Component } from "react"
import PropTypes from "prop-types"
import * as Icon from "react-feather"

class SearchFilterCheckbox extends Component {
  onOptionClick = () => {
    const { onClick, value } = this.props

    onClick(value)
  }

  render() {
    const { active, label, className } = this.props

    return (
      <div
        role="button"
        className={`${className} search-filter__filter${
          active ? " search-filter__filter--selected" : ""
        }`}
        onClick={this.onOptionClick}
        onKeyPress={this.onOptionClick}
        tabIndex={0}
      >
        {active ? (
          <Icon.CheckSquare className="search-filter__filter-icon icon icon--sm" />
        ) : (
          <Icon.Square className="search-filter__filter-icon icon icon--sm" />
        )}
        <span className="search-filter__filter-text">{label}</span>
      </div>
    )
  }
}

SearchFilterCheckbox.defaultProps = {
  className: "",
  onClick: () => {},
  active: false,
}

SearchFilterCheckbox.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  value: PropTypes.shape({
    field: PropTypes.string,
    option: PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func,
  active: PropTypes.bool,
}

export default SearchFilterCheckbox
